import React from 'react';
import BigHeader from '../../components/BigHeader';
import Container from 'react-bootstrap/Container';
import Silico from './Silico';
import Mathematical from './Mathematical';

const Model = () => {

    return (
        <div>
            <BigHeader headerText={"Models"} backgroundImage={"https://static.igem.wiki/teams/4602/wiki/images/images/background.jpg"}/>
            <Container style={{marginLeft: '50px', marginBottom: '100px', marginTop: '8px', alignItems: 'stretch', marginRight:'50px'}} >
                <Mathematical/>
                <Silico/>
            </Container>
        </div>
    )
}
export default Model;